module.exports = __webpack_public_path__ + "img/brand-logo.f5a8a366.svg";